import { render, staticRenderFns } from "./MonetizingConfig.vue?vue&type=template&id=a51f4d8a&"
import script from "./MonetizingConfig.vue?vue&type=script&lang=js&"
export * from "./MonetizingConfig.vue?vue&type=script&lang=js&"
import style0 from "./MonetizingConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports